import React from "react";
import "./grid.css";
import akash from "../../images/institute.png";
import { AiFillStar } from "react-icons/ai";
import { BsBookmark } from "react-icons/bs";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { GoLocation } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { baseLocal, baseUrl } from "../../context/BaseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VacancyGrid = (props) => {
  const val = localStorage.getItem("user");
  const user = JSON.parse(val);
  const id = user.user._id;
  const token = user.token;
  // console.log(id);

  const BookMarked = async (value) => {
    try {
      const data = {
        vacancy_id: value,
        user_id: id,
      };
      const response = await fetch(
        `${baseLocal}/user/user_rights/postvacancy/${id}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();
    //   alert(result);
      if (result) {

        if(result.error == 500){
            toast.error(result.msg)
        }
        toast.success(result.msg)

        props.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={`grid-card save-courses-mobile d-md-block ${
          props.dis ? "d-none" : "d-block"
        }`}
      >
        <div className="logo d-flex justify-content-between">
          <img src={props.image} alt="akash" />
          <h6 onClick={() => BookMarked(props.vacancy_id)}>
            {" "}
            <BsBookmark />
          </h6>
        </div>
        <h5 className="name">{props.name}</h5>
        <p className="p-abt">{props.about}</p>
        <p className="location">
          {" "}
          <GoLocation /> {props.location}{" "}
        </p>
        <div className="buttons d-md-flex d-none">
          {/* <button className='view'>View Courses</button> */}
          <button className="more">
            <Link to={`/vacancy-detail/${props.vacancy_id}`}>Know More</Link>
          </button>
        </div>
      </div>
      <Link
        className="text-decoration-none text-black"
        to={`/vacancy-detail/${props.vacancy_id}`}
      >
        <div
          className={`grid-card save-courses-mobile d-md-none ${
            props.dis ? props.dis : "d-none"
          }`}
        >
          <div className="logo d-flex">
            <img src={props.image} alt="akash" />
            <div className="center">
              <h5 className="name py-0">{props.name}</h5>
            </div>
            <h6 onClick={() => BookMarked(props.vacancy_id)}>
              {" "}
              <BsBookmark />
            </h6>
            <h6>
              {" "}
              <BiDotsVerticalRounded />
            </h6>
          </div>
          <p className="location">
            {" "}
            <GoLocation /> {props.location}{" "}
          </p>
          <p className="p-abt text-truncate vacancy-about">{props.about}</p>
          <div className="buttons d-md-flex d-none">
            {/* <button className='view'>View Courses</button> */}
            <button className="more">
              <Link to={`/vacancy-detail/${props.vacancy_id}`}>Know More</Link>
            </button>
          </div>
        </div>
      </Link>
    </>
  );
};

export default VacancyGrid;
